<template>
	<div>

		<v-alert outline type="warning" :value="true">
			<div>
				<strong>Formulaire déprécié</strong>
			</div>
			Veuillez utiliser la nouvelle version du launcher.
		</v-alert>
		<v-form ref="launch_form">

			<div v-for="param in wf_data.parameters" :key="param.name">

					<div v-if="param.name === 'legacy_contract_id'">
						<v-autocomplete
							:items="options.contracts"
							:hint="get_hint(param)"
							persistent-hint
							clearable
							dense
							item-value="id"
							:filter="customContractsFilter"
							open-on-clear
							@change="get_contract_assets();form_change()"
							:rules="get_validation_rules(param.type, param.required)"
							v-model="form.parameters[param.name]">
							<template v-slot:label>
								{{ param | maestroParamLabel }}
							</template>
							<template v-slot:selection="data">
								<v-list-tile-content>
									<v-list-tile-title>
										{{ data.item.id }} - {{ data.item.name }} - {{ data.item.title }}
									</v-list-tile-title>
								</v-list-tile-content>
							</template>
							<template v-slot:item="data">
								<template>
									<v-list-tile-content>
										<v-list-tile-title>
											{{ data.item.id }} - {{ data.item.name }} - {{ data.item.title }}
										</v-list-tile-title>
										<v-list-tile-sub-title v-if="data.item.content_owner">
											{{ data.item.content_owner.name }}
										</v-list-tile-sub-title>
									</v-list-tile-content>
								</template>
							</template>
						</v-autocomplete>
					</div>

					<div v-if="param.name === 'asset_ids'">
						<v-autocomplete
							:items="options.asset_list"
							:hint="get_hint(param)"
							persistent-hint
							multiple
							clearable
							dense
							@change="form_change()"
							item-text="mat_id"
							item-value="mat_id"
							no-data-text="Aucun asset trouvé"
							:rules="[validations['array-filled']]"
							v-model="selected_assets">
							<template v-slot:label>
								{{ param | maestroParamLabel }}
							</template>
						</v-autocomplete>
					</div>

					<!-- <div v-if="param.name === 'is_signed'">
						<v-checkbox
							color="primary"
							:rules="[validations.truethy]"
							@change="form_change()"
							v-model="form.parameters[param.name]">
							<template v-slot:label>
								Le contrat a-t-il été signé <span v-if="param.required">*</span>
							</template>
						</v-checkbox>
					</div>

					<div v-if="param.name === 'signature_date'">
						<v-menu
							v-model="show_date_picker"
							:close-on-content-click="false"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							offset-y
							full-width
							min-width="290px">
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="form.parameters[param.name]"
									prepend-icon="event"
									readonly
									@change="form_change()"
									:rules="[validations.required]"
									v-on="on">
									<template v-slot:label>
										{{ param | maestroParamLabel }}
									</template>
								</v-text-field>
							</template>
							<v-date-picker
								v-model="form.parameters[param.name]"
								@input="show_date_picker = false" />
						</v-menu>
					</div>

					<div v-if="param.name === 'Size'">
						<v-text-field
							dense
							@change="form_change()"
							label="Size"
							:rules="[validations.required]"
							v-model="form.parameters[param.name]">
						</v-text-field>
					</div>

					<div v-if="param.name === 'is_paid'">
						<v-checkbox
							color="primary"
							@change="form_change()"
							:hint="get_hint(param)"
							:rules="[validations.truethy]"
							v-model="form.parameters[param.name]">
							<template v-slot:label>
								Le contrat a-t-il été payé ? <span v-if="param.required">*</span>
							</template>
						</v-checkbox>
					</div> -->
			</div>

		</v-form>

		<v-card class="pa-2 mb-3" v-if="debug">
			<tree-view :data="form" :options="{maxDepth: 3, rootObjectKey: 'Output'}" />
		</v-card>

		<v-card class="pa-2" v-if="debug">
			<tree-view :data="wf_data" :options="{maxDepth: 0, rootObjectKey: 'Job Descriptor'}" />
		</v-card>

	</div>
</template>

<script>

export default {
	name: '',
	props: ['debug', 'wf_data', 'details'],
	data () {
		return {
			form: {
				isValid: false,
				jobdescriptorID: null,
				jobDescriptorVersion: null,
				parameters: {}
			},
			selected_assets: [],
			show_date_picker: false,
			options: {
				contracts: [],
				asset_list: []
			},
			validations: {
				'boolean': v => typeof (v) === 'boolean' || 'Doit être true ou false',
				'email': v => /.+@.+/.test(v) || 'Mauvaise mise en forme de l\'email',
				'multi-email': v => this.multi_email_check(v) || 'Mauvaise mise en forme des emails',
				'integer': v => Number.isInteger(v) || 'Nombre entier uniquement',
				'mutli-integer': v => this.multi_integer_check(v) || 'Nombres entiers uniquement',
				'json': v => this.json_check(v) || 'Mauvaise mise en forme JSON',
				'array-filled': v => this.array_filled_check(v) || 'ne doit pas être vide',
				'required': v => !!v || 'Requis',
				'truethy': v => v === true || 'Doit être coché'
			}
		}
	},
	watch: {
		selected_assets: function (val) {
			this.form.parameters.asset_list = val.join(', ')
		}
	},
	methods: {

		customContractsFilter (item, queryText, itemText) {
			const name = item.name.toLowerCase()
			const title = item.title.toLowerCase()
			const id = item.id.toString()
			const content_owner = item.content_owner.name.toLowerCase()
			const searchText = queryText.toLowerCase()
			return name.indexOf(searchText) > -1 ||
				title.indexOf(searchText) > -1 ||
				id.indexOf(searchText) > -1 ||
				content_owner.indexOf(searchText) > -1
		},

		get_contract_assets () {
			this.selected_assets = []
			this.options.asset_list = []
			let contractId = this.form.parameters.legacy_contract_id
			if (!Number.isInteger(contractId)) return
			this.$apiPublic.get_legacy_contract_assets(contractId)
				.then(asset_ids => {
					this.options.asset_list = asset_ids
					this.selected_assets = asset_ids
				})
				.catch(error => {
					console.error('get_contract_assets', error)
				})
		},

		get_validation_rules (fieldType, required) {
			let rules = []
			if (this.validations.hasOwnProperty(fieldType)) {
				rules.push(this.validations[fieldType])
			}
			if (required) rules.push(this.validations.required)
			return rules
		},

		get_hint (param) {
			let hint = `[${param.type}] `
			if (param.help) {
				hint += param.help
			}
			if (param.type.indexOf('multi-') > -1) {
				hint += ' (séparés par des virgules)'
			}
			return hint
		},

		form_change () {
			this.$forceUpdate()
			this.$nextTick((arg) => {
				this.form.jobdescriptorID = this.wf_data.descriptor_id
				this.form.jobDescriptorVersion = this.wf_data.version_number
				this.form.isValid = this.$refs.launch_form.validate()
				this.$emit('change', [this.form])
			})
		},

		json_check (str) {
			try {
				JSON.parse(str)
				return true
			} catch (e) {
				return false
			}
		},

		array_filled_check (arr) {
			if (typeof (arr) === 'object' && arr.length > 0) {
				return true
			}
			return false
		},

		multi_email_check (str) {
			let isValid = true
			str.split(',').map(email => {
				if (!/.+@.+/.test(email)) isValid = false
			})
			return isValid
		},

		multi_integer_check (str) {
			let isValid = true
			str.split(',').map(number => {
				let int = parseInt(number, 10)
				if (!Number.isInteger(int)) isValid = false
			})
			return isValid
		},

		getContracts () {
			this.$apiPublic.get_legacy_contracts()
				.then(results => {
					this.options.contracts = results
				})
				.catch(error => {
					console.error('getContracts', error)
				})
		}
	},
	mounted () {
		this.form.isValid = false
		this.form.parameters = {}
		this.wf_data.parameters.map(desc => {
			let defaultValue = ''
			if (desc.default !== '') defaultValue = desc.default
			if (this.details) {
				if (this.details.hasOwnProperty(desc.name)) {
					defaultValue = this.details[desc.name]
				}
			}
			this.form.parameters[desc.name] = defaultValue
		})
		if (this.details.hasOwnProperty('asset_list')) {
			this.selected_assets = this.details['asset_list']
		}
		this.$nextTick((arg) => {
			if (this.$refs.launch_form) {
				this.getContracts()
				this.form.isValid = this.$refs.launch_form.validate()
				this.form_change()
				if (this.details.hasOwnProperty('asset_list')) {
					this.options.asset_list = this.details['asset_list']
				}
			}
		})
	}
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_legacy_archive_contract.vue